/**
 * @file Resize executor base
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { ExecutorBase } from './executor';
var ResizeBase = /** @class */ (function (_super) {
    tslib_1.__extends(ResizeBase, _super);
    /**
    * Creates an instance of ResizeBase.
    * @param {string} name The name of executor
    * @param {string} label The label for the exectur (for localisation)
    * @param {ExecutorScope[]} scopes The executor has support for these scopes
    */
    function ResizeBase(name, label, scopes, category, domainService, overlayService, dropTargetsService, diaglogService, translateService, userService, resourceService) {
        var _this = _super.call(this, name, label, scopes, 'Resize', category, domainService, overlayService, dropTargetsService, diaglogService, translateService, userService, resourceService) || this;
        // The success message for the Resize executors
        _this.successMessage = 'APP.EXECUTORS.RESIZE_SUCCESS_MESSAGE';
        return _this;
    }
    /**
     * The business logic for this executor and is executed after the
     * validation step and before the finish step.
     *
     * @param {ExecutorData} data The executor data
     * @returns {Promise<any>}
     */
    ResizeBase.prototype.process = function (data) {
        var _this = this;
        // Your magic here inside an async promise
        return new Promise(function (resolve, reject) {
            data.targets.forEach(function (target) {
                data.items.forEach(function (item) {
                    item['Finish'] = target.finish.toDate();
                    item['Start'] = target.start.toDate();
                });
            });
            _this.saveChanges(reject, resolve);
        });
    };
    /**
     * Validate the executor data
     * @protected
     * @param {ExecutorData} data The executor datea
     * @returns {Promise<any>}
     */
    ResizeBase.prototype.validate = function (data) {
        var _this = this;
        // Make sure the given items are of the correct type
        return this.validateItems(data.items).then(function () {
            // Check the target timeslot
            return _this.validateTimeslots('targets', data.targets, false);
        });
    };
    return ResizeBase;
}(ExecutorBase));
export { ResizeBase };
